module.exports = __webpack_public_path__ + "static/media/Roboto-Regular.94dac78e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Regular.woff
// module id = 541
// module chunks = 0